module.exports = __webpack_public_path__ + "img/clase.13e1a7dd.svg";